import {
  IonTabs,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonIcon,
  IonLabel,
} from '@ionic/react';
import {
  calendarOutline,
  personCircleOutline,
  newspaperOutline,
  peopleCircleOutline,
  homeOutline,
} from 'ionicons/icons';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router';
import AccountTab from './account/AccountTab';
import EventsRouting from './events/EventsRouting';
import NewsRouting from './news/NewsRouting';
import NotificationsList from './notifications/NotificationsList';
import { useContext } from 'react';
import { AppContext } from '../../lib/context/AppContext';
import TripRouting from './trips/TripRouting';
import HomePage from '../public/HomePage';

const AuthenticatedRoutes: React.FC = () => {
  const match = useRouteMatch();
  const { user, isLoading } = useContext(AppContext);
  // if (!user && !isLoading) {
  //   window.location.href = '/auth';
  // }
  return (
    <>
      <IonTabs>
        <IonRouterOutlet>
          <Switch>
            <Route path='/events'>
              <EventsRouting />
            </Route>
            <Route path='/trips'>
              <TripRouting />
            </Route>
            <Route path='/news'>
              <NewsRouting />
            </Route>
            <Route path='/account'>
              {!user && !isLoading ? <Redirect to='/auth' /> : <AccountTab />}
            </Route>
            <Route path='/notifications'>
              <NotificationsList />
            </Route>
            <Route path='/'>
              <HomePage />
            </Route>
          </Switch>
        </IonRouterOutlet>
        <IonTabBar slot='bottom'>
          <IonTabButton tab='home' href='/' selected={match.url === '/'}>
            <IonIcon aria-hidden='true' icon={homeOutline} />
            <IonLabel>Home</IonLabel>
          </IonTabButton>
          <IonTabButton
            tab='events'
            href='/events'
            selected={match.url === '/events'}
          >
            <IonIcon aria-hidden='true' icon={calendarOutline} />
            <IonLabel>Eventi</IonLabel>
          </IonTabButton>
          <IonTabButton
            tab='trips'
            href='/trips'
            selected={match.url === '/trips'}
          >
            <IonIcon aria-hidden='true' icon={peopleCircleOutline} />
            <IonLabel>People</IonLabel>
          </IonTabButton>
          <IonTabButton
            tab='news'
            href='/news'
            selected={match.url === '/news'}
          >
            <IonIcon aria-hidden='true' icon={newspaperOutline} />
            <IonLabel>News</IonLabel>
          </IonTabButton>
          <IonTabButton
            tab='account'
            href='/account'
            selected={match.url === '/account'}
          >
            {user?.picture?.url && (
              <img
                alt='Profile'
                src={user?.picture?.url}
                className='w-10 h-10 rounded-full object-cover'
              ></img>
            )}
            {!user?.picture?.url && (
              <>
                <IonIcon aria-hidden='true' icon={personCircleOutline} />
                <IonLabel>Account</IonLabel>
              </>
            )}
          </IonTabButton>
        </IonTabBar>
      </IonTabs>
    </>
  );
};

export default AuthenticatedRoutes;
